import { ReactComponent as Tabal } from "../assets/img/comparses/tabal-sol.svg";
import { ReactComponent as Turcs } from "../assets/img/comparses/turcs-sol.svg";
import { ReactComponent as Maces } from "../assets/img/comparses/maces-sol.svg";
import { ReactComponent as Angels } from "../assets/img/comparses/angels-sol.svg";
import { ReactComponent as Guites } from "../assets/img/comparses/guites-sol.svg";
import { ReactComponent as Aliga } from "../assets/img/comparses/aliga-sol.svg";
import { ReactComponent as NansVells } from "../assets/img/comparses/nans-vells-sol.svg";
import { ReactComponent as Gegants } from "../assets/img/comparses/gegants-sol.svg";
import { ReactComponent as NansNous } from "../assets/img/comparses/nans-nous-sol.svg";
import { ReactComponent as Plens } from "../assets/img/comparses/plens-sol.svg";

import tabal from "../assets/img/comparses/png/tabal.png";
import aliga from "../assets/img/comparses/png/aliga.png";
import cavallets from "../assets/img/comparses/png/cavallets.png";
import gegants from "../assets/img/comparses/png/gegants.png";
import guita_gran from "../assets/img/comparses/png/guita_gran.png";
// import guita_xica from "../assets/img/comparses/png/guita_xica.png";
import maces from "../assets/img/comparses/png/maces.png";
import nans_nous from "../assets/img/comparses/png/nans_nous.png";
import nans_vells from "../assets/img/comparses/png/nans_vells.png";
import plens from "../assets/img/comparses/png/plens.png";
import turcs from "../assets/img/comparses/png/turcs.png";
import angels from "../assets/img/comparses/png/angels.png";

export const comparses = [
	{ id: "tabal", nom: "Tabal", icon: Tabal, png: tabal, ordre: 1 },
	{ id: "turcs", nom: "Turcs", icon: Turcs, png: turcs, ordre: 2 },
	{ id: "cavallets", nom: "Cavallets", icon: Turcs, png: cavallets, ordre: 3 },
	{ id: "maces", nom: "Maces", icon: Maces, png: maces, ordre: 4 },
	{ id: "angels", nom: "Àngels", icon: Angels, png: angels, ordre: 5 },
	// { id: "guita-xica", nom: "Guita Xica", icon: Guites, png: guita_xica, ordre: 6 },
	{ id: "guita-gran", nom: "Guites", icon: Guites, png: guita_gran, ordre: 7 },
	{ id: "aliga", nom: "Aliga", icon: Aliga, png: aliga, ordre: 8 },
	{ id: "nans-vells", nom: "Nans Vells", icon: NansVells, png: nans_vells, ordre: 9 },
	{ id: "gegants", nom: "Gegants", icon: Gegants, png: gegants, ordre: 10 },
	{ id: "nans-nous", nom: "Nans Nous", icon: NansNous, png: nans_nous, ordre: 11 },
	{ id: "plens", nom: "Plens 1r salt", icon: Plens, png: plens, ordre: 12 },
	{ id: "plens2", nom: "Plens 2n salt", icon: Plens, png: plens, ordre: 13 },
];
